export default function (disableMenu) {
  return {
    items: [
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'house-fill',
        badge: {
          variant: 'primary'
        },
        attributes: { disabled: disableMenu }
      },
      {
        name: 'Keluar',
        url: '/logout',
        icon: 'power',
        class: 'mt-auto',
        variant: 'success'
      }
    ]
  }
}
